{ normalizeNumber } = require 'utils/phones'

window.TIMEZONES = ["Asia/Almaty", "Asia/Anadyr", "Asia/Baku", "Asia/Irkutsk", "Asia/Kamchatka", "Asia/Krasnoyarsk", "Asia/Magadan", "Asia/Novokuznetsk", "Asia/Novosibirsk", "Asia/Omsk", "Asia/Sakhalin", "Asia/Srednekolymsk", "Asia/Tashkent", "Asia/Tbilisi", "Asia/Ust-Nera", "Asia/Vladivostok", "Asia/Yakutsk", "Asia/Yekaterinburg", "Asia/Yerevan", "Europe/Kaliningrad", "Europe/Kiev", "Europe/Minsk", "Europe/Moscow", "Europe/Riga", "Europe/Samara", "Europe/Tallinn", "Europe/Ulyanovsk", "Europe/Volgograd", '','—','',"Africa/Algiers", "Africa/Cairo", "Africa/Casablanca", "Africa/Harare", "Africa/Johannesburg", "Africa/Monrovia", "Africa/Nairobi", "America/Argentina/Buenos_Aires", "America/Bogota", "America/Caracas", "America/Chicago", "America/Chihuahua", "America/Denver", "America/Godthab", "America/Guatemala", "America/Guyana", "America/Halifax", "America/Indiana/Indianapolis", "America/Juneau", "America/La_Paz", "America/Lima", "America/Los_Angeles", "America/Mazatlan", "America/Mexico_City", "America/Monterrey", "America/New_York", "America/Phoenix", "America/Regina", "America/Santiago", "America/Sao_Paulo", "America/St_Johns", "America/Tijuana", "Asia/Baghdad", "Asia/Bangkok", "Asia/Chongqing", "Asia/Colombo", "Asia/Dhaka", "Asia/Hong_Kong", "Asia/Jakarta", "Asia/Jerusalem", "Asia/Kabul", "Asia/Karachi", "Asia/Kathmandu", "Asia/Kolkata", "Asia/Kuala_Lumpur", "Asia/Kuwait", "Asia/Muscat", "Asia/Rangoon", "Asia/Riyadh", "Asia/Seoul", "Asia/Shanghai", "Asia/Singapore", "Asia/Taipei", "Asia/Tehran", "Asia/Tokyo", "Asia/Ulaanbaatar", "Asia/Urumqi", "Atlantic/Azores", "Atlantic/Cape_Verde", "Atlantic/South_Georgia", "Australia/Adelaide", "Australia/Brisbane", "Australia/Darwin", "Australia/Hobart", "Australia/Melbourne", "Australia/Perth", "Australia/Sydney", "Etc/UTC", "Europe/Amsterdam", "Europe/Athens", "Europe/Belgrade", "Europe/Berlin", "Europe/Bratislava", "Europe/Brussels", "Europe/Bucharest", "Europe/Budapest", "Europe/Copenhagen", "Europe/Dublin", "Europe/Helsinki", "Europe/Istanbul", "Europe/Lisbon", "Europe/Ljubljana", "Europe/London", "Europe/Madrid", "Europe/Paris", "Europe/Prague", "Europe/Rome", "Europe/Sarajevo", "Europe/Skopje", "Europe/Sofia", "Europe/Stockholm", "Europe/Vienna", "Europe/Vilnius", "Europe/Warsaw", "Europe/Zagreb", "Pacific/Apia", "Pacific/Auckland", "Pacific/Fakaofo", "Pacific/Fiji", "Pacific/Guam", "Pacific/Honolulu", "Pacific/Majuro", "Pacific/Midway", "Pacific/Noumea", "Pacific/Pago_Pago", "Pacific/Port_Moresby", "Pacific/Tongatapu"]

App.ApplicationController = Em.Controller.extend
  session:  Em.inject.service()
  realTime: Em.inject.service()
  env:      Em.inject.service('environment')
  sip:      Em.inject.service()
  notifier: Em.inject.service()

  routerContainer: (->
    @container.lookup('router:main')
  ).property('routerContainer')

  currentRouteParams: ->
    routerContainer = @get('routerContainer')
    currentPathes = routerContainer.router.currentHandlerInfos
    return null unless currentPathes
    _.last currentPathes?.map (handlerInfo) => handlerInfo.params

  billingBinding: 'session.currentBilling'

  isBoard2linkEnabled: Em.computed.alias('env.features.boardShowBoard2Link')

  isExternalIntegrationsLink: localStorage.getItem('integrationsSettings') == 'false'

  prevMessageId: null

  main: (->
    ###
    # Пытаемся всегда взять хоть какую-то локаль
    ###

    # console.log Em.I18n
    # debugger


    # numeral.language 'ru',
    #   delimiters:
    #     thousands: ' '
    #     decimal: '.'
    #   abbreviations:
    #     thousand: 'тыс.'
    #     million:  'млн.'
    #     billion:  'млрд.'
    #     trillion: 'трил.'
    #   currency:
    #     symbol: '₽'

    locale = localStorage.getItem('interfaceLocale') || @get('session.locale')
    locale = Em.keys(Em.I18n.locales)[0] unless Em.I18n.locales[ locale ]

    # locale = 'en'

    Em.Logger.log "Выбрана локаль приложения #{locale}"
    @get('env').set('locale', locale)

    Em.I18n.translations = Em.I18n.locales[ locale ]
    Em.I18n.locale = locale
    # numeral.language(locale)
    moment.locale(locale)
    if @get('env.features.communicationChannels')
      baseRoot = @get('env.apiRoot')
      key = @get('session.apiKey')
      url = "#{baseRoot}/api/clients/unprocessed_counts"
      ajaxProps = 
          url: url
          dataType: 'json'
          headers: 'Authorization': "Token token=\"#{key}\""
          
      Ember.$.ajax(ajaxProps).then (data) =>
        @set('unreadCount', data.clients_count)
    realTime = @get('realTime')
    realTime.on('unprocessedCountsUpdated', @, (data) =>
      @set('unreadCount', data.clients_count)
    )      

    realTime.on('clientMessageCreated', @ , (data) =>
      return if data.id is @get('prevMessageId')
      @set('prevMessageId', data.id)
      ctx = @
      params = @currentRouteParams() 
      return unless data.incoming 
      return if data.client_id is Number params.client_id
      client = @store.find('client', data.client_id).then (c) =>
        @get('notifier').pushNotification
          type: 'message'
          title: c.get('name') or c.get('phone')
          message: data.text or Em.I18n.t ('communication_channels.incoming' )
          duration: 5000
          handler: ->
            ctx.transitionToRoute('clients.client', c)

    )   
  ).on('init')


  unreadCount: null

  # ---
  # Логика по формированию строки для верхней панели информации
  # (сообщения об оплате, блокировке и т.д.)
  # Берем billingInfo из текущей сессии и проверяем
  # ---
  billingWarningMessage: (->
    billing = @get('billing')

    if billing
      fmtDate = (t) -> moment(t).format('D MMMM')

      # Напомнить, что сейчас ознакомительный период и нужно перейти на тарифный план
      if billing.get('paywall_warning')
        return @get('env').translate('billing.warnings.paywall_warning',
          deadline: fmtDate(billing.get('paywall_deadline')))

      # Прошел ознакомительный период и пользователь не принял условия
      if billing.get('paywall_expired')
        return @get('env').translate('billing.warnings.paywall_expired')

      # Триал и не подтвердили использование услуг
      if not billing.get('paywall_accepted')
        return @get('env').translate('billing.warnings.trial_period',
          deadline: fmtDate(billing.get('paywall_deadline')))

      # Организацию просто заблокировали из-за неуплаты
      if billing.get('blocked')
        return @get('env').translate('billing.warnings.blocked')

      # Находимся на бесплатном тарифе
      if false and billing.get('has_free_tariff')
        return @get('env').translate('billing.warnings.free_tariff')

      # Есть долг, но еще не заблокировали
      blockDate = billing.get('estimated_block_date')
      if blockDate
        deptSum   = billing.get('absoluteBalance')

        return @get('env').translate('billing.warnings.dept_detected',
          sum: @get('env').translate_billing_currency(deptSum),
          deadline: fmtDate(blockDate))

      balance = billing.get('balance')
      invoicesTotal = billing.get('pending_invoices_sum')
      haveToPay = invoicesTotal - balance

      # Есть выставленные счета, которые еще не списали с баланса
      if invoicesTotal > 0 and haveToPay > 0
        return @get('env').translate('billing.warnings.pending_invoices',
          sum: @get('env').translate_billing_currency(haveToPay),
          deadline: fmtDate(billing.get('next_checkout_date')))


    if @get('env.features.restaurantRushMode')
      rush_mode_restaurants_info = @get('rush_mode_restaurants_info')
      unless rush_mode_restaurants_info
        @store.find('restaurant').then (restaurants) =>
          disabled = total = 0
          restaurants.forEach (rest,i) =>
            total += 1
            disabled += 1 if rest.get('is_rush_mode')

          if disabled > 0
            @set 'rush_mode_restaurants_info', @get('env').translate('billing.warnings.rush_mode_restaurants', {total, disabled})
          else
            @set 'rush_mode_restaurants_info', ''
      else
        return rush_mode_restaurants_info if rush_mode_restaurants_info != ''

    blocked_restaurants_info = @get('blocked_restaurants_info')
    unless blocked_restaurants_info
      @store.find('restaurant').then (restaurants) =>
        disabled = total = 0
        restaurants.forEach (rest,i) =>
          total += 1
          disabled += 1 unless rest.get('is_running')

        if disabled > 0
          @set 'blocked_restaurants_info', @get('env').translate('billing.warnings.blocked_restaurants', {total, disabled})
        else
          @set 'blocked_restaurants_info', ''
    else
      return blocked_restaurants_info if blocked_restaurants_info != ''

    ''
  ).property(
    'blocked_restaurants_info',
    'rush_mode_restaurants_info',
    'billing',
    'billing.balance',
    'billing.has_free_tariff'
    'billing.trial_active',
    'billing.trial_expires_at',
    'billing.paywall_accepted',
    'billing.paywall_warning',
    'billing.paywall_deadline',
    'billing.pending_invoices_sum',
    'billing.next_checkout_date'
    'billing.blocked',
    'billing.estimated_block_date',
    'billing.absoluteBalance')

  isBillingClass: (->
    billing = @get('billing')
    props = ['paywall_warning', 
    'paywall_expired', 
    'paywall_accepted', 
    'has_free_tariff',
    'trial_active',
    'blocked']
    if billing
      return props.some (prop) => billing.get(prop)
  ).property(
    'billing',
    'billing.balance',
    'billing.has_free_tariff'
    'billing.trial_active',
    'billing.paywall_accepted',
    'billing.paywall_warning',
    'billing.blocked')

  loadClientsByNumber: (number) ->
    # if @get('session.multipleOrganizations')
    #   return Em.RSVP.resolve([])

    @get('store').find('client', { phone_number: number })


  # ---
  # Обработчик нажатия на уведомление о новом звонке
  # ---
  callNotificationClickHandler: (options) ->
    { number, client } = options

    # клиент известен — перейти в его карточку
    if client
      @transitionToRoute('clients.client', client)

    else if number
      # есть только номер и несколько организаций — предложить выбрать из списка
      if @get('session.multipleOrganizations')
        @set('lastKnownNumber', number)
        @set('isSelectOrganizationModalShown', true)
      else
        @transitionToRoute('orders.create', queryParams: { number: options.number })

  # ---
  # Обработчик входящих звонков от sip-сервиса
  # Звонок приводит к отсылке сообщения 'call' sip-сервиса, а
  # мы находим клиента и отображаем уведомление через notifier
  # ---
  sipHandler: (->
    @get('sip').on('call', (phoneNumber) =>
      @incomingCallHandler(phoneNumber)
    )
    @get('realTime').on('incoming_call', (phoneNumber) =>
      @incomingCallHandler(phoneNumber)
    )
  ).on('init')

  incomingCallHandler: (number) ->
    phoneNumber = normalizeNumber(number)

    @loadClientsByNumber(phoneNumber)
    .then (clients) =>
      imageUrl  = undefined
      # todo i18n
      title     = "Входящий звонок в #{ moment().format('HH:mm') }"
      handler   = @callNotificationClickHandler.bind(@, { number: phoneNumber})

      clients.forEach (client) =>
        imageUrl  = client.get('avatar')
        # todo i18n
        title     = "Звонит #{client.get('name')} в #{ moment().format('HH:mm') }"
        handler   = @callNotificationClickHandler.bind(@, { client })

      displayPhone = phoneNumber
      clientsA = clients.toArray()

      if clientsA.length
        client = clientsA[0]
        client.get('phones').forEach (p) =>
          if normalizeNumber(phoneNumber) is normalizeNumber(p.get('number'))
            displayPhone = p.get('number')

      @get('notifier').pushNotification {
        type: 'image'
        imageUrl: imageUrl
        title: title
        message: displayPhone
        handler: handler
      }


  # ---
  # Модальное окно поддержки должно открываться в любом роуте, поэтому
  # пользуемся флагами и эмулируем состояние роута
  # ---
  isSupportModalShown: false
  supportModalMessage: ''

  isSelectOrganizationModalShown: false

  # ---
  # Поповер для меню под профилем
  # С ним всегда возникают проблемы, далее идет серия фиксов,
  # чтобы закрывать его при логауте и нажатии на кнопки
  # ---
  popoverOpened: false

  closePopoverOnLogout: (->
    user = @get('session.currentUser')
    if not user
      @set('popoverOpened', false)
  ).observes('session.currentUser')

  actions:
    orderOrganizationSelected: (organization) ->
      @set('isSelectOrganizationModalShown', false)

      @transitionToRoute('orders.create', queryParams: {
        number: @get('lastKnownNumber')
        organization_id: organization.get('id')
      })
      false

    closeOrganizationSelectModal: ->
      @set('isSelectOrganizationModalShown', false)
      false

    openSipSettings: ->
      @transitionToRoute('settings.profile')
      false

    openYandexBusinessSettings: ->
      @transitionToRoute('settings.yandex_business')
      false

    resolveTopLevelWarning: ->
      rushModeInfo = @get('rush_mode_restaurants_info') && @get('rush_mode_restaurants_info') != ''
      blockedInfo = @get('blocked_restaurants_info') && @get('blocked_restaurants_info') != ''
      isBillingClass = @get('isBillingClass')
      if (rushModeInfo || blockedInfo) && !isBillingClass
        @transitionToRoute('restaurants.index')
        return false

      # if @get('billing.paywall_accepted')
      @transitionToRoute('settings.billing')
      # else
      #   @transitionToRoute('settings.billing.tariffs')
      false

    popoverClicked: (e) ->
      @set 'popoverOpened', false
      false

    profileEdit: ->
      @transitionToRoute('profile')
      false

    profileLogout: ->
      @transitionToRoute('auth.logout')
      false

    closeSupportModal: ->
      @set('isSupportModalShown', false)
      false
